import React, { useState } from 'react';

const EXTENSION_PUBLIC_PAGE_URL = 'https://chromewebstore.google.com/detail/ichliiaibpojaeammmmnafhncgbokbci?utm_source=theezy-dashboard'

type ExtensionParams = {
    showExtensionPromo: boolean | undefined;
    activate: boolean
}
const ExtensionBanner = ( { showExtensionPromo, activate } : ExtensionParams) => {
    const [ dismissed, setDismissed ] = useState<boolean>(false);

    const handleInstallClick = () => {
        window.open(EXTENSION_PUBLIC_PAGE_URL, '_blank');
    };

    return (activate && showExtensionPromo) && !dismissed ? (
        <div className="ext-banner">
            <div className="ext-banner-inner">
                <div className="ext-banner-left">
                    <div className="ext-banner-dot" />
                    <div className="ext-banner-text">
                        <strong>Extension required</strong> — install the Theezy browser extension to start earning rewards.
                    </div>
                </div>
                <div className="ext-banner-right">
                    <button className="ext-install-btn" onClick={handleInstallClick}>Install Extension</button>
                    <button className="ext-dismiss-btn" onClick={() => setDismissed(true)}>✕</button>
                </div>
            </div>
        </div>
    ) : null;
}

export default ExtensionBanner;
